import Vue from 'vue';

export const allowToResetInvoiceBus = new Vue();
export const fillOrderBus = new Vue();
export const chatUpdated = new Vue();
export const updateOrderedDrugs = new Vue();
export const updateDynamicStoreData = new Vue();
export const customUpdateData = new Vue();
